<template>
  <DBox :id="'cmp-accounting-costs-cost_details'" :addButton="false">
    <Dropdown2
      id="invoice_project_id"
      :label="$dft.capHead($t('invoice_project1'))"
      :placeholder="$t('select')+' ' + $dft.capHead($t('invoice_project1'))"
      :disabled="false"
      :options="invoiceProjectsTV"
      :selected="
        invoiceProjectsTV.find(
          (e) => e.value == selectedCostsDetails.invoice.invoice_project_id
        )
      "
      v-on:selectedChange="(e) => onDropdownChange('invoice_project_id', e)"
    />
    <DatePicker2
      id="invoice_date"
      :placeholder="$t('date')"
      :label="$t('date')"
      :value="selectedCostsDetails.invoice.invoice_date"
      @input="onDateUpdate"
    />

    <Dropdown2
      id="currency_id"
      :label="$dft.capHead($t('currency'))"
      :placeholder="$t('select')+' ' + $dft.capHead($t('currency'))"
      :disabled="false"
      :options="currencyTV"
      :selected="
        currencyTV.find(
          (e) => e.value == selectedCostsDetails.invoice.currency_id
        )
      "
      v-on:selectedChange="(e) => onDropdownChange('currency_id', e)"
    />

    <TextField2
      id="creditor_no"
      :placeholder="$dft.capHead($t('creditor'))"
      :label="$dft.capHead($t('creditor'))"
      :value="selectedCostsDetails.creditor_no"
      @blur="(e) => onTextFieldValueChange(e)"
    />
    <TextField2
      id="external_ref"
      :placeholder="$dft.capHead($t('external_no'))"
      :label="$dft.capHead($t('external_no'))"
      :value="selectedCostsDetails.invoice.external_ref"
      @blur="(e) => onTextFieldValueChange(e)"
    />
    <TextField2
      id="invoice_ref"
      :placeholder="$dft.capHead($t('internal_no'))"
      :label="$dft.capHead($t('internal_no'))"
      :value="selectedCostsDetails.invoice.invoice_ref"
      @blur="(e) => onTextFieldValueChange(e)"
    />
    <Dropdown2
      id="cost_group_id"
      :label="$dft.capHead($t('cost_group'))"
      :placeholder="$t('select')+' ' + $dft.capHead($t('cost_group'))"
      :disabled="false"
      :options="costGroupTV"
      :selected="
        costGroupTV.find(
          (e) => e.value == selectedCostsDetails.invoice.cost_group_id
        )
      "
      v-on:selectedChange="(e) => onDropdownChange('cost_group_id', e)"
    />

    <TextField2
      id="performance_country"
      :placeholder="$dft.capHead($t('country'))"
      :label="$dft.capHead($t('country'))"
      :value="selectedCostsDetails.invoice.performance_country"
      @blur="(e) => onTextFieldValueChange(e)"
    />
    <TextField2
      id="due_days"
      :placeholder="$dft.capHead($t('due_days'))"
      :label="$dft.capHead($t('due_days'))"
      :value="selectedCostsDetails.invoice.due_days"
      :bb="'0px'"
      @blur="(e) => onTextFieldValueChange(e)"
    />
  </DBox>
</template>
<script>
import { createTV, tv } from "../../../../models/text-value.model";

export default {
  props: ["selectedCostsDetails"],

  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
      },
      licence_account_name: "",
      keyword: "",
      business_status: "",
    };
  },
  methods: {
    onTextFieldValueChange: function ({ name, value }) {
      this.selectedCostsDetails.invoice[name] = value;

      this.$emit("changed", { name, value });
    },
    onDropdownChange: function (name, value) {
      this.selectedCostsDetails.invoice[name] = value.value;
      const payload = {
        name: name,
        value: value.value,
      };
      this.$emit("changed", payload);
    },
    onDateUpdate: function ({ name, value }) {
      this.selectedCostsDetails.invoice[name] = value;
      this.$emit("changed", { name, value });
    },
  },
  computed: {
    invoiceProjectsTV: function () {
      return createTV(
        this.selectedCostsDetails?.invoice_projects,
        "invoice_project_name",
        "invoice_project_id"
      );
    },
    costGroupTV: function () {
      return createTV(
        this.selectedCostsDetails?.cost_groups,
        "cost_group_name",
        "cost_group_id"
      );
    },

    currencyTV: function () {
      return createTV(
        this.selectedCostsDetails?.currencies,
        "currency_iso",
        "currency_id"
      );
    },
  },
};
</script>
<style lang="scss">
.cmp-accounting-costs-cost_details {
  .flex-container {
    display: flex;
    padding: 10px;
    .flex-item {
      flex: 0.25;
      padding: 10px;
    }
  }
}
</style>
